import React from "react";
import StorySection from "../components/StorySection";
import CTASection from "../components/CTASection";
import TestimonialsSection from "../components/TestimonialsSection";
import PageHero from "../components/PageHero";
import { SITE_ASSETS } from "../mock";
import { useSettings } from "../context/SettingsContext";

const pillars = [
  { t: "Craft",      d: "Hand-curated material palettes and architecture detailing on every facade and lobby." },
  { t: "Restraint",  d: "Luxury defined by proportion and quietness, never by ornament for its own sake." },
  { t: "Longevity",  d: "Buildings engineered to age gracefully — in finish, in mechanical systems and in service." },
  { t: "Service",    d: "A relationship that begins, not ends, at handover. Concierge-grade post-sales care." },
];

export default function AboutPage() {
  const { settings } = useSettings();
  return (
    <>
      <PageHero
        eyebrow={`About ${settings.brandName}`}
        title="A Quieter Luxury."
        italicWord="Luxury"
        description="Tamra was founded with a simple intent — to build residences that feel inevitable. Spaces that age beautifully, lobbies that whisper, and skylines that the city remembers."
        image={SITE_ASSETS.hero.aerial}
      />

      <section className="py-20 bg-[#F5EFE6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-12 items-center">
          <div className="aspect-[4/5] overflow-hidden">
            <img src={SITE_ASSETS.hero.building} alt="Tamra building" className="w-full h-full object-cover img-hover" />
          </div>
          <div>
            <div className="section-eyebrow mb-5">Our Practice</div>
            <h2 className="section-title font-display mb-8">Built around <span className="italic text-[#B8893C]">four pillars</span>.</h2>
            <div className="divide-y divide-[#EBE0CE] border-y border-[#EBE0CE]">
              {pillars.map((p, i) => (
                <div key={p.t} className="py-6 grid grid-cols-12 gap-4">
                  <div className="col-span-2 text-[11px] tracking-[0.4em] text-[#B8893C]">0{i + 1}</div>
                  <div className="col-span-10">
                    <div className="font-display text-2xl tracking-[0.05em] text-[#1F1B17] mb-2">{p.t}</div>
                    <p className="text-[#3a322a] leading-relaxed text-sm">{p.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <StorySection />

      <section className="py-28 bg-[#EBE0CE]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
          {[{ n: "15+", l: "Years of Craft" }, { n: "3.2M", l: "Sq.Ft Delivered" }, { n: "2,400+", l: "Happy Families" }, { n: "7", l: "Iconic Addresses" }].map((s) => (
            <div key={s.l}>
              <div className="font-display text-5xl md:text-6xl text-[#5C2018] tracking-[0.04em]">{s.n}</div>
              <div className="text-[11px] tracking-[0.4em] uppercase text-[#3a322a] mt-3">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <TestimonialsSection />
      <CTASection />
    </>
  );
}
